module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "parameter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "name": "single",
      "id": "single"
    },
    domProps: {
      "value": _vm.single_mode,
      "checked": _vm._q(_vm.mode, _vm.single_mode)
    },
    on: {
      "__c": function($event) {
        _vm.mode = _vm.single_mode
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "single"
    }
  }, [_vm._v("single")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "name": "loop",
      "id": "loop"
    },
    domProps: {
      "value": _vm.loop_mode,
      "checked": _vm._q(_vm.mode, _vm.loop_mode)
    },
    on: {
      "__c": function($event) {
        _vm.mode = _vm.loop_mode
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "loop"
    }
  }, [_vm._v("loop")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "name": "order",
      "id": "order"
    },
    domProps: {
      "value": _vm.order_mode,
      "checked": _vm._q(_vm.mode, _vm.order_mode)
    },
    on: {
      "__c": function($event) {
        _vm.mode = _vm.order_mode
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "order"
    }
  }, [_vm._v("order")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "name": "listing",
      "id": "circulation"
    },
    domProps: {
      "value": _vm.circulation_mode,
      "checked": _vm._q(_vm.mode, _vm.circulation_mode)
    },
    on: {
      "__c": function($event) {
        _vm.mode = _vm.circulation_mode
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "circulation"
    }
  }, [_vm._v("circulation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "name": "random",
      "id": "random"
    },
    domProps: {
      "value": _vm.random_mode,
      "checked": _vm._q(_vm.mode, _vm.random_mode)
    },
    on: {
      "__c": function($event) {
        _vm.mode = _vm.random_mode
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "random"
    }
  }, [_vm._v("random")])]), _vm._v(" "), _c('div', {
    staticClass: "audio-container"
  }, _vm._l((_vm.lists), function(list, index) {
    return _c('vue-audio', {
      key: index,
      attrs: {
        "source": list.source,
        "index": index,
        "mode": _vm.mode
      },
      on: {
        "timeupdate": _vm.timeupdate,
        "playing": _vm.playing,
        "pause": _vm.pause,
        "ended": _vm.ended,
        "waiting": _vm.waiting,
        "error": _vm.error
      }
    }, [_c('div', {
      staticClass: "player"
    }, [_c('svg', {
      staticClass: "progress",
      attrs: {
        "width": _vm.svgOptions.width,
        "height": _vm.svgOptions.height
      }
    }, [_c('path', {
      attrs: {
        "fill": _vm.svgOptions.fill,
        "stroke": _vm.svgOptions.stroke,
        "stroke-width": _vm.svgOptions.strokeWidth
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "play",
      attrs: {
        "href": "javascript:void(0)"
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-2f0ab110!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 10
// module chunks = 1